<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >
                    <div class="header-image-gradient" style="background-image: url(static/images/img3.jpg);">
                        <div class="layer-gradient"></div>
                    </div>                

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                        </h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">
                        <div class="col-lg-12 margin-bottom-20" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'marketing'">
                            <router-link :to="{'name': 'CadastrarPosts'}" class="button block-mobile transparent">
                                <i class="material-icons">add</i>
                                Cadastrar nova dica
                            </router-link>
                        </div>                                        
                        <div class="col-xs-12 col-lg-12 col-xl-12">
                            <div class="dashboard-box margin-top-0 cards">
                                <div class="content">
                                    <h5 class="block-title">
                                        <i class="material-icons">access_time</i>
                                        Dicas e novidades recentes
                                    </h5>
                                                                        
                                    <h5 v-if="data.itens.length == 0 && data.loaded" class="empty">
                                        <i class="material-icons">close</i>                                            
                                        Nenhum resultado encontrado.
                                    </h5>

                                    <div class="dashboard-box-list margin-top-0" v-show="data.itens.length > 0">
                                        <a class="job-listing card" v-for="(item, index) in data.itens" v-on:click="open(item.cod)">
                                            <div class="header-image" v-if="item.arquivo" :style="{'background-image': 'url(' + $root.config.url + '/' + item.arquivo + ')'}">
                                            </div>
                                            <div class="job-listing-details">

                                                <div class="job-listing-description">
                                                    <h3 class="job-listing-title margin-bottom-0" style="line-height: 130%;">{{item.objeto.titulo}}</h3>
<!--                                                     <div class="margin-top-5 margin-bottom-5 v-html" v-html="item.objeto.texto">
                                                    </div> -->
                                                    <h5>
                                                        <i class="material-icons">access_time</i>
                                                        {{item.datahora | formatDate}}
                                                    </h5>  
                                                    <button type="button" v-on:click.stop.prevent="$root.go('EditarPosts', JSON.stringify({'c': item.cod}))" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'marketing'" class="dashboard-status-button gray" style="border-color: #aaa !important;">
                                                        <i class="material-icons">edit</i> Editar
                                                    </button>                                                    
                                                    <button v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'marketing'" type="button" class="dashboard-status-button gray" v-on:click.stop.prevent="del(item.cod)" style="border-color: #aaa !important;">
                                                        <i class="material-icons">delete</i> Apagar
                                                    </button>          
                                                    <div style="height: 10px; width: 100%;" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'marketing'"></div>                                                
                                                </div>
                                            </div>
                                        </a>
                                        
                                        
                                    </div>
                                </div>
                            </div>                            
                        </div>  
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

        <div id="modal-post" class="modal">
            <div class="row" v-if="detalhes">
                <div class="col-lg-12">
                    <div class="header-image" v-if="detalhes.arquivo" :style="{'background-image': 'url(' + $root.config.url + '/' + detalhes.arquivo + ')'}"></div>
                        <div class="job-listing-details" style="padding: 15px 0px;">
                            <div class="job-listing-description">
                                <h3 class="job-listing-title margin-bottom-0">{{detalhes.objeto.titulo}}</h3>
                                <div class="margin-top-15 margin-bottom-15 v-html" v-html="detalhes.objeto.texto">
                                </div>
                                <h5>
                                    <i class="material-icons">access_time</i>
                                    Criado em {{detalhes.datahora | formatDate}}
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Posts',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            "detalhes":             null,
            "data":                 {
                "itens":            []
            },          
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token
            },
        }
    },
    watch: {
                  
    },
    methods: {  
        open: function(cod) {
            console.log("open", cod)
            var self        = this;

            loading.show();

            window.__modalPost   = new tingle.modal({
                footer:         false,
                stickyFooter:   false,
                closeMethods:   ['overlay', '', 'escape'],
                closeLabel:     "",
                cssClass:       ["modal-post"]
            });   

            var form = {
                "params": {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "nome":         "post",
                    "cod":          cod
                }
            };

            axios.get("api/itens.php", form)
            .then(response => {
                
                console.log("openDetalhes() response", response);
                self.detalhes       = response.data.result;
                
                setTimeout(function() {
                    window.__modalPost.setContent(document.querySelector('#modal-post').innerHTML);      
                    window.__modalPost.open();
                    loading.hide();
                    setTimeout(function() {
                        $(".modal-post").append('<a class="close" onclick="window.__modalPost.close();"><i class="material-icons">close</i></a>');    
                    }, 100);
                }, 500);

            })
            .catch(error => {
                console.log("openDetalhes() error", error);                    
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });   

        },         
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                loading.show();
                
                axios.delete("api/itens.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.get().then(function() {
                        loading.hide();
                    }).catch(function() {
                        loading.hide();
                    });                 
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },             
        get: function() {
            var self        = this;
            console.log("get()");
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "nome":         "post",
                        "multiplo":     true
                    }
                };

                axios.get("api/itens.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data           = response.data.result;
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        }
    },
    created: function() {
        var self = this;

        loading.show();

        if (self.$route.query.c) {
            self.open(self.$route.query.c);
        }

        Promise.all([
            self.get()
        ]).then(function() {
        
            self.$forceUpdate();
            setTimeout(function() {
                loading.hide();
            }, 1000);
            
        }).catch(function(error) {
            loading.hide();
        });         

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    div.float-right {
        float: right;
        display: inline-block;
    }
    .dashboard-status-button {
        padding-top: 0px;
        margin-right: 5px;
        color: #333;
        font-weight: 300;
        padding-top: 2px !important;
        line-height: 20px;
        top: 5px;
        margin-top: 0px;
        border: 1px solid #ddd;
        margin-top: 0px;
        display: inline-block;
        position: relative;
    }
    .dashboard-status-button i {
        /*color: #fff;*/
        display: inline-block !important;
        top: 1px;
        margin-top: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Posts.vue